import * as React from 'react';
import { IconProps } from '../types';

export const UnsourceMarketplaceIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ size = 200, ...props }, forwardedRef) => (
    <svg 
        width={size} 
        height={size} 
        viewBox="0 0 32 32" 
        {...props} 
        ref={forwardedRef}><path d="M12.453.005a3 3 0 0 0-.646.089C10 .505 8.932 2.313 9.343 4.125l1.87 6.729-6.724-2.208C2.765 8.073.874 9.057.296 10.787c-.573 1.724.411 3.615 2.135 4.193l7.807 2.557-5.417 6.078a3.5 3.5 0 0 0-.828 2.219 3.303 3.303 0 0 0 3.292 3.286c.906 0 1.807-.411 2.469-1.151l4.75-5.302 1.911 6.865a3.326 3.326 0 0 0 3.203 2.469h.005c.245 0 .573-.083.823-.161a3.355 3.355 0 0 0 2.297-4.115l-1.839-6.688 6.609 2.167c.411.083.74.161 1.068.161 1.484 0 2.719-.901 3.125-2.302.578-1.724-.411-3.615-2.135-4.193l-7.641-2.505 5.422-6.047c1.229-1.401 1.151-3.453-.25-4.688-1.396-1.234-3.453-1.151-4.688.245l-4.76 5.344-1.901-6.906C15.321.875 13.946-.062 12.451.006z"/></svg>
  )
);

UnsourceMarketplaceIcon.displayName = 'UnsourceMarketplaceIcon';